import { render } from "./App.vue?vue&type=template&id=3c0c2fa2"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=3c0c2fa2&lang=scss"

import exportComponent from "C:\\Users\\dslx464\\Desktop\\workspace\\certificatesystem\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__